import React from 'react';
import ScrollReveal from '../animations/ScrollReveal';

/**
 * Wrapper that gives every section the same vertical rhythm, container width
 * and heading treatment, so spacing stays consistent as sections are added.
 */
export default function Section({
  id,
  eyebrow,
  title,
  lead,
  align = 'center',
  className = '',
  containerClassName = '',
  headingClassName = '',
  children
}) {
  const headingId = id ? `${id}-heading` : undefined;
  const isCentered = align === 'center';

  return (
    <section
      id={id}
      aria-labelledby={headingId}
      className={`relative overflow-hidden py-section-sm sm:py-section ${className}`}
    >
      <div className={`relative z-10 mx-auto w-full max-w-7xl px-6 ${containerClassName}`}>
        {(eyebrow || title) && (
          <ScrollReveal direction="up">
            <div
              className={`mb-14 sm:mb-16 ${
                isCentered ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'
              } ${headingClassName}`}
            >
              {eyebrow && <p className="eyebrow">{eyebrow}</p>}
              {title && (
                <h2 id={headingId} className="section-title mt-4">
                  {title}
                </h2>
              )}
              {lead && <p className="section-lead">{lead}</p>}
            </div>
          </ScrollReveal>
        )}
        {children}
      </div>
    </section>
  );
}
